import { HashRouter } from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';
import AnimationManager from './components/AnimationManager';
import AnimatedRoutes from './components/AnimatedRoutes';
import CookieBanner from './components/CookieBanner';

import './App.css';

export default function App() {
  return (
    <HashRouter>
      <AnimationManager />
      <Header />
      <main>
        <AnimatedRoutes />
      </main>
      <Footer />
      <CookieBanner />
    </HashRouter>
  );
}